
/* ===============================
   GLOBAL CLICK HANDLER
=============================== */
document.addEventListener("click", async function(e){

  const wrapper = document.getElementById("mystery-offer-wrapper");
  const modal = document.getElementById("mysteryModal");

  if (!wrapper) return;

  /* WRAPPER CLICK → OPEN MODAL */
  if (
    wrapper.classList.contains("mystery-enabled") &&
    e.target.closest("#mystery-offer-wrapper") &&
    !e.target.closest("#mysteryDrawerBtn") && 
    !e.target.closest(".quantity__price__mystery_wrapper")
  ) {
    if (modal) modal.style.display = "flex";
    peopleCounter();
  }


  /* CLOSE MODAL */
  if (modal) {
    if (e.target.closest(".mystery-close") || e.target === modal) {
      modal.style.display = "none";
    }
  }

});

/* ESC KEY */
document.addEventListener("keydown", function(e){
  if (e.key === "Escape") {
    const modal = document.getElementById("mysteryModal");
    if (modal) modal.style.display = "none";
  }
});


/* =========================================
   ADD MYSTERY BUNDLE (DYNAMIC + LOADING)
========================================= */

document.addEventListener("click", async function(e){

  const btn = e.target.closest(".mystery-add-btn");
  if (!btn) return;

  if (!window.MYSTERY_VARIANTS || !window.MYSTERY_VARIANTS.length) return;

  const originalText = btn.innerText;

  try {

    // 🔥 Show loading state
    btn.disabled = true;
    btn.innerText = "Adding...";

    const items = window.MYSTERY_VARIANTS.map(id => ({
      id: id,
      quantity: 1,
      properties: { _mystery_bundle: "true" }
    }));

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ items })
    });

    if (!response.ok) throw new Error("Add failed");
    // 🎯 Track bundle addition with Clevertap
     clevertap.event.push("Mystery_Box_Added", {
        source: "cart_drawer",
        bundle_products: window.MYSTERY_VARIANTS,
        timestamp: new Date().toISOString()
      });

    await refreshDrawer();
    // 🎉 Fire confetti inside drawer
    setTimeout(() => {
       fireMysteryConfetti();
    }, 500);
   
  

  } catch (error) {
    console.error("Mystery bundle error:", error);
  } finally {

  }

});

// Refresh cart drawer contents
async function refreshDrawer() {

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const response = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer`);
  const data = await response.json();

  drawer.renderContents({
    sections: {
      "cart-drawer": data["cart-drawer"]
    }
  });
  // ✅ Restart timer after drawer render
  setTimeout(() => {
    startMysteryTimer();
  }, 500);
}

// Handle quantity changes for mystery bundle items in the cart drawer
document.addEventListener("click", async function(e){

  const plusBtn = e.target.closest(".mystery-plus");
  const minusBtn = e.target.closest(".mystery-minus");

  if (!plusBtn && !minusBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const cart = await fetch('/cart.js').then(r => r.json());

  /* 🔥 Define your 3 mystery variant IDs */
  // const mysteryVariantIds = [
  //   43444506361949,
  //   43444680786013,
  //   43687709999197
  // ];
  const mysteryVariantIds = window.MYSTERY_VARIANTS;

  /* 🔥 Filter by variant_id (MORE RELIABLE) */
  const mysteryItems = cart.items.filter(item =>
    mysteryVariantIds.includes(item.variant_id)
  );

  console.log("All mystery items:", mysteryItems);

  if (!mysteryItems.length) return;

  const currentQty = mysteryItems[0].quantity;

  let newQty = plusBtn
    ? currentQty + 1
    : currentQty - 1;

  if (newQty < 0) return;

  const updates = {};

  mysteryItems.forEach(item => {
    updates[item.key] = newQty;
  });

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({ updates })
  });

  await refreshDrawer();
});

function fireMysteryConfetti() {

  const canvas = document.getElementById('cartDrawerConfetti');
  if (!canvas || typeof confetti === "undefined") return;

  const myConfetti = confetti.create(canvas, {
    resize: true,
    useWorker: true
  });

  const count = 200;
  const defaults = {
    origin: { y: 0.6 }
  };

  function fire(particleRatio, opts) {
    myConfetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio)
      })
    );
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55
  });

  fire(0.2, {
    spread: 60
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45
  });

  // Clear canvas after animation
  setTimeout(() => {
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }, 2000);
}

// async function autoRemoveMysteryIfNeeded(qtyState) {

//   const cart = await fetch('/cart.js').then(r => r.json());

//   if (!window.MYSTERY_VARIANTS || !window.MYSTERY_VARIANTS.length) return;

//   const mysteryVariantIds = window.MYSTERY_VARIANTS;

//   let normalQty = 0;
//   const mysteryItems = [];

//   cart.items.forEach(item => {

//     if (mysteryVariantIds.includes(item.variant_id)) {
//       mysteryItems.push(item);
//     } else {
//       if(qtyState.type === "decrease") {
//         normalQty += item.quantity - 1; // Assume 1 item removed
//       } else {
//       normalQty += item.quantity;
//       }
//     }

//   });

//   console.log("Normal items quantity:", normalQty);
//   console.log("Mystery items in cart:", mysteryItems);

//   // 🚨 If normal qty < 3 and mystery exists
//   if (normalQty < 3 && mysteryItems.length) {

//     const updates = {};

//     mysteryItems.forEach(item => {
//       updates[item.key] = 0;
//     });
//      console.log("updates:", updates);
//     await fetch('/cart/update.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ updates })
//     });

//     // 🔥 Use your existing refreshDrawer
//     await refreshDrawer();
//   }
// }

// document.addEventListener("click", function(e){

//   // Trigger only for normal cart items
//   if (e.target.closest('.cart-quantity .quantity__button')) {

//   const qtyBtn = e.target.closest('.cart-quantity .quantity__button');
//   if (!qtyBtn) return;

//   const action = qtyBtn.getAttribute("name"); // "plus" or "minus"

//   const state = {
//     type: action === "plus" ? "increase" : "decrease"
//   };

//   console.log("Quantity Action State:", state);
//     // Wait for Dawn to update cart first
//     setTimeout(() => {
//       autoRemoveMysteryIfNeeded(state);
//     }, 500);

//   }

// }); 

async function autoRemoveMysteryIfNeeded(state, clickedVariantId) {

  const cart = await fetch('/cart.js').then(r => r.json());

  if (!window.MYSTERY_VARIANTS || !window.MYSTERY_VARIANTS.length) return;

  const mysteryVariantIds = window.MYSTERY_VARIANTS;

  let normalQty = 0;
  const mysteryItems = [];

  cart.items.forEach(item => {

    if (mysteryVariantIds.includes(item.variant_id)) {
      mysteryItems.push(item);
      return;
    }

    // Gift box doesn't count towards mystery box eligibility
    if (item.properties && item.properties._gift_box === "true") return;

    // If this is the clicked product
    if (item.variant_id === clickedVariantId && state.type === "decrease") {
      normalQty += Math.max(item.quantity - 1, 0);
    } else if (item.variant_id === clickedVariantId && state.type === "increase") {
      normalQty += item.quantity + 1;
    } else {
      normalQty += item.quantity;
    }

  });

  console.log("Correct Normal Qty:", normalQty);

  // Remove mystery if rule breaks
  if (normalQty < 3 && mysteryItems.length) {

    const updates = {};

    mysteryItems.forEach(item => {
      updates[item.key] = 0;
    });

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    await refreshDrawer();
  }
}

document.addEventListener("click", function(e){

  const qtyBtn = e.target.closest('.cart-quantity .quantity__button');
  if (!qtyBtn) return;

  const input = qtyBtn.closest('.cart-quantity').querySelector('.quantity__input');
  if (!input) return;

  const variantId = parseInt(input.dataset.quantityVariantId);

  // Ignore mystery quantity changes
  if (window.MYSTERY_VARIANTS.includes(variantId)) return;

  const action = qtyBtn.getAttribute("name");

  const state = {
    type: action === "plus" ? "increase" : "decrease"
  };

  console.log("Quantity Action:", state, "Variant:", variantId);

  setTimeout(() => {
    autoRemoveMysteryIfNeeded(state, variantId);
     // NEW
    startMysteryTimer();

  }, 500);

});


function peopleCounter() {
   const boughtEl = document.querySelector(".people-bought");
  const viewingEl = document.querySelector(".people-viewing");

  if(!boughtEl || !viewingEl) return;

  function getRandomNumber(min,max){
    return Math.floor(Math.random()*(max-min+1))+min;
  }

  const boughtCount = getRandomNumber(50,150);
  const viewingCount = getRandomNumber(500,700);

  boughtEl.innerHTML = boughtCount;
  viewingEl.innerHTML = viewingCount;
}

document.addEventListener("DOMContentLoaded", function(){

  peopleCounter();

});


/* =========================
   MYSTERY TIMER
========================= */

window.mysteryTimerRemaining = 5 * 60;
window.mysteryTimerInterval = null;

function startMysteryTimer() {

  console.log("Timer Started");
  const timerEl = document.getElementById("mysteryTimer");

  // Timer element missing
  if (!timerEl) return;

  // 🔥 IMPORTANT
  // Always clear old interval before creating new one
  clearInterval(window.mysteryTimerInterval);

  // Render immediately
  renderMysteryTimer();

  // Start interval
  window.mysteryTimerInterval = setInterval(() => {

    window.mysteryTimerRemaining--;

    if (window.mysteryTimerRemaining < 0) {
      window.mysteryTimerRemaining = 5 * 60;
    }

    renderMysteryTimer();

  }, 1000);
}

/* =========================
   RENDER TIMER
========================= */

function renderMysteryTimer() {

  // console.log("Timer Render", document.getElementById("mysteryTimer"));
  const timerEl = document.getElementById("mysteryTimer");

  // Timer element no longer exists
  if (!timerEl) return;

  const minutes = Math.floor(window.mysteryTimerRemaining / 60);
  const seconds = window.mysteryTimerRemaining % 60;

  timerEl.innerHTML =
    `${String(minutes).padStart(2,'0')}:${String(seconds).padStart(2,'0')}`;
}

/* =========================
   INITIAL LOAD
========================= */

document.addEventListener("DOMContentLoaded", function () {

  peopleCounter();

  setTimeout(() => {
    startMysteryTimer();
  }, 800);

});


